import React, { useMemo } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { possibleGames } from "../fortune-wheel-data";

interface FortuneWheelTableProps {
  sectors?: HallFortuneWheelSector[];
}

const FortuneWheelTable: React.FC<FortuneWheelTableProps> = ({ sectors }) => {
  const safeSectors: HallFortuneWheelSector[] = useMemo(() => {
    if (sectors) {
      return sectors.slice(0, 12);
    }
    return new Array(12).fill(0).map(() => ({ type: 1, amount: 0, active: "ENABLE" }));
  }, [sectors]);
  const [t] = useTranslation();
  const games = useMemo(() => Object.fromEntries(possibleGames.map(game => [game.game, game])), []);
  return <Table size="small" stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell>{t("ru.halls.wager.fortune_wheel.sectors.idx")}</TableCell>
        <TableCell>{t("ru.halls.wager.fortune_wheel.sectors.win")}</TableCell>
        <TableCell>{t("ru.halls.wager.fortune_wheel.sectors.active")}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {safeSectors.map((sector, idx) => <TableRow key={idx}>
        <TableCell>{idx + 1}</TableCell>
        <TableCell>{sector.type === 1 ? sector.amount : `${sector.amount} фриспинов в "${games[sector.game].name}" с деноминацией ${(sector as HallFortuneWheelSectorFreespeen).denomination / 100}`}</TableCell>
        <TableCell>{t("ru.halls.wager.fortune_wheel.active." + (sector.active ?? "ENABLE"))}</TableCell>
      </TableRow>)}
    </TableBody>
  </Table>;
}

export default FortuneWheelTable;
